import { createFileRoute } from "@tanstack/react-router";
import SummaryTabPanel from "@/components/dashboard/summary-tab-panel";

export const Route = createFileRoute("/_app/dashboard/")({
	component: SummaryTabPanel,
});
